interface WordmarkProps {
  className?: string;
  size?: 'small' | 'medium' | 'large';
}

export default function Wordmark({ className = '', size = 'medium' }: WordmarkProps) {
  return <span className={`wordmark wordmark-${size} ${className}`.trim()}>Sheahan Studios</span>;
}
